module.exports = __webpack_public_path__ + "static/media/science4.12c8357c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/img/science4.jpg
// module id = 585
// module chunks = 0